import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PrimeNGConfig } from 'primeng/api';
import { element } from 'protractor';
import { AuthService } from 'src/app/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from '../users.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-add',
  templateUrl: './user-add.component.html',
  styleUrls: ['./user-add.component.scss']
})
export class UserAddComponent implements OnInit {
  full_name: any;
  user_name: any;
  password: any;
  confirm_password: any;
  isEdit: boolean = false;
  buttonDisabled: boolean = false;
  loader: boolean = false;
  user_type: any;
  profile: any;
  usertypes: any[] = []
  profileIds: any[] = [];
  error: string;
  showPassw0rdFields: boolean = false;
  isTextFieldType1: boolean = false;
  isTextFieldType2: boolean = false;
  userStrategy: any;
  allUsersList: any[]=[];
  currentUser: any;
  currentUserid:any
  constructor(private userService: UsersService, public router: Router,
    private toaster: ToastrService, private modalService: NgbModal, public service: AuthService,
    public dialogRef: MatDialogRef<UserAddComponent>,
    @Inject(MAT_DIALOG_DATA) public inputdata: any
  ) { }
  ngOnInit() {
    this.currentUser = localStorage.getItem('user_id');
    this.isEdit = this.inputdata.action == 'Edit' ? true : false;
    // this.getList();
    this.getcurrentUser().then((res:any)=>{
      this.currentUserid = res?.result?._source?.user_type;
           this.getList();
    })
    this.getUsersList();
    if (this.isEdit) {
      this.user_name = this.inputdata.params.data._id;
      this.full_name = this.inputdata.params.data._source.fullname;
      this.user_type = this.inputdata.params.data._source.user_type;
      this.profile = this.inputdata.params.data._source.profileIds;
      this.getUserStrategry();
    }
  }
  getUsersList() {
    this.loader = false;
    let params = {};

    params = {
      "query": {},
      sort: [{ "_kuzzle_info.createdAt": "asc" }]
    }
    this.userService.getAllUsers(params).subscribe((res: any) => {
      this.allUsersList = res?.result?.hits;    
      
    }, err => {
      this.loader = false;

    })
  }

    getcurrentUser() {
    return new Promise((resolve, reject)=>{
    this.userService.getCurrentUser().subscribe({next:(data: any) => {
      resolve(data);
    },
    error: (err: any) => {
      resolve({});
    }
  })
  })
  }


  getList() {
    this.loader = true;
    this.userService.getAllRoles().subscribe((data: any) => {
      let rowData = data.result.hits;
      let offData = [];
      rowData.map((item: any) => {
              if (item._source.type == 'user_role') {
                if(this.currentUserid=="admin"||item._source.visibility){
                        offData.push({
                          id: item._id,
                          name: this.camalize(item._id),
                          profile: item._source.profileIds
                        })
                }
              }
            }
         )
         
      this.usertypes = offData;
      if (!this.isEdit) {
        this.user_type = this.usertypes[0].id;
        this.profile = this.usertypes[0].profile;
      }
      this.loader = false;
    }, err => {
      this.loader = false;
    })
  }
  getUserStrategry() {
    this.userStrategy = null;
    this.userService.getStrategyOfUser(this.user_name).subscribe((res: any) => {
      this.userStrategy = res?.result.strategies[0];
    }, err => {
      this.userStrategy = null;
    })
  }
  camalize(mySentence: any) {
    return mySentence.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
  }


  changeFullName($event: any) {
    this.error = '';
  }
  changeUserType(event: any) {
    let obj = this.usertypes.filter(o => o.id == event);
    this.profile = obj[0].profile;
  }
  changeUserName($event: any) {
    const obj = this.allUsersList?.filter(o => o._id == this.user_name);

    console.log(obj)
    if(obj?.length > 0 && !this.isEdit) {
      this.error = 'User name already exist';
    } else {
    this.error = '';
    }

  }

  closePopup() {
    this.dialogRef.close();

  }
  changeConfirmPassword(e) {
    if (this.password != this.confirm_password) {
      // this.error = 'Password and Confirm password did not match'
    } else {
      this.error = '';
    }
  }
  changePasswordlink() {
    this.showPassw0rdFields = !this.showPassw0rdFields;
    if (!this.showPassw0rdFields && this.password && this.confirm_password) {
      this.error = '';
    }
  }
  togglePasswordFieldType(type) {
    if (type == 1) {
      this.isTextFieldType1 = !this.isTextFieldType1;
    } else {
      this.isTextFieldType2 = !this.isTextFieldType2;
    }

  }
  createRecord() {

    const obj = this.allUsersList?.filter(o => o._id == this.user_name);
   
    if (!this.full_name) {
      this.error = 'Full name can not be blank';
    } else if (!this.user_name) {
      this.error = 'User name can not be blank';

    } else if(obj?.length > 0 && !this.isEdit) {
      this.error = 'User name already exist';
    } else if (this.password != this.confirm_password && this.isEdit && this.showPassw0rdFields) {
      this.error = 'Password and Confirm password did not match'
    } else if (this.password != this.confirm_password && !this.isEdit) {
      this.error = 'Password and Confirm password did not match'
    } else if (!this.user_type) {
      this.error = 'Please select User type';

    } else if (!this.profile) {
      this.error = 'Please select at least one Profile';

    } else {
      this.loader = true;

      if (this.isEdit) {

        let payload = {
          "user_type": this.user_type,
          "fullname": this.full_name,
          "profileIds": this.profile
        }
        console.log("payload else", payload)
        this.userService.updateUser(payload, this.user_name).subscribe(result => {
          this.toaster.success('User information updated successfully')
        });
        if (this.showPassw0rdFields && this.password && this.confirm_password && (this.password == this.confirm_password) && this.userStrategy == 'local') {
          let p: any = this.handleEncrypt(this.confirm_password);
          this.userService.updateUserPassw0rdByAdmin(this.user_name, p).subscribe(result => {
            this.loader = false;
            this.isTextFieldType1 = false;
            this.isTextFieldType2 = false;
            this.dialogRef.close();
            if (this.user_name == localStorage.getItem('user_id')) {
              this.toaster.warning('Password Updated Please Login Again');
              localStorage.clear();
              this.router.navigateByUrl('/login');
            }
          }, err => {
            this.loader = false;
          })
        } else {
          this.loader = false;
          this.dialogRef.close();
        }


      } else {
        let p: any = this.handleEncrypt(this.password);
        let payload = {
          "content": {
            "user_type": this.user_type,
            "fullname": this.full_name,
            "profileIds": this.profile,
          },
          "credentials": {
            "local": {
              "username": this.user_name,
              "password": p
            }
          }
        }
        this.userService.createUserByAdmin(payload, this.user_name).subscribe((res) => {
          this.toaster.success('New user created successfully')
          this.loader = false;
          this.isTextFieldType1 = false;
          this.isTextFieldType2 = false;
          this.dialogRef.close();
        }, err => {
          this.loader = false;
        })

      }
    this.showPassw0rdFields = false;


    }


  }
  validateName(e) {  //to stop entering the special charators except -

    var k;
    k = e.charCode;    //  k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }
  handleEncrypt(value) {
    return this.service.encryptUsingAES256(value)
  }
  isFormValid(): boolean {
  if (!this.full_name || !this.user_name || !this.user_type) return false;

  if (!this.isEdit) {
    if (!this.password || !this.confirm_password || this.password !== this.confirm_password) return false;
  }

  return true;
}
}


